if (!customElements.get('tpb-pairs-carousel')) {
  class TpbPairsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-tpb-pairs-track]');
      this.previousButton = this.querySelector('[data-tpb-pairs-prev]');
      this.nextButton = this.querySelector('[data-tpb-pairs-next]');

      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.handlePrevious = () => this.scrollByCard(-1);
      this.handleNext = () => this.scrollByCard(1);
      this.updateButtons = () => {
        const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.previousButton.disabled = this.track.scrollLeft <= 1;
        this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 1;
      };

      this.previousButton.addEventListener('click', this.handlePrevious);
      this.nextButton.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.updateButtons, { passive: true });
      window.addEventListener('resize', this.updateButtons, { passive: true });
      this.updateButtons();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.track?.removeEventListener('scroll', this.updateButtons);
      window.removeEventListener('resize', this.updateButtons);
    }

    scrollByCard(direction) {
      const firstCard = this.track.querySelector('.tpb-pairs__card');
      if (!firstCard) return;

      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = firstCard.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }
  }

  customElements.define('tpb-pairs-carousel', TpbPairsCarousel);
}
